module.exports = __webpack_public_path__ + "img/mobile-banner1-zh.712f606b.jpg";